import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useWindowSize from '@hooks/useWindowSize';

import AdminList from '@features/admin/components/AdminList';
import DepartmentList from '@features/admin/components/DepartmentList';
import RoleList from '@features/admin/components/RoleList';
import TeamList from '@features/admin/components/TeamList';
import Chip from '@features/filter/Chip';
import { adminPageFieldList, teamPageFieldList } from '@features/filter/static/filterUtil';
import FilterComponent from '@features/filter/v1/FilterComponent';

const Admin = () => {
	const [showSearchBox, setShowSearchBox] = useState(false);
	const [showAdd, setShowAdd] = useState(false);
	const [activeStep, setActiveStep] = useState(null);
	const [search, setSearch] = useState('');
	const [total, setTotal] = useState('');
	const [showFilter, setShowFilter] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	useWindowSize(() => setShowFilter(false));

	const totalItems = (value) => {
		setTotal(value);
	};

	const handleClick = () => {
		setShowAdd(true);
	};

	const onTabChange = (tabType) => {
		setActiveStep(tabType);
		navigate(`/admins/list?activeTab=${tabType}`, { replace: true });
	};

	const checkActiveTab = () => {
		let activeTabName = new URLSearchParams(location.search).get('activeTab');

		if (activeStep !== activeTabName && location.search !== '') {
			setActiveStep(activeTabName);
		} else {
			setActiveStep('ADMINLIST');
		}
	};

	const handleChange = (e) => {
		setSearch(e.target.value);
	};
	const addNewAdmin = () => {
		navigate('/admins/add');
	};
	const addNewRole = () => {
		navigate('/roles/add');
	};
	const addNewTeam = () => {
		navigate('/teams/add');
	};

	useEffect(() => {
		checkActiveTab();
	}, []);

	return (
		<>
			<div className="top-header bg-white admin-top-header">
				<div className="page-title-area">
					<h1 className="semibold-16">
						<img
							src={`${process.env.PUBLIC_URL}/icons/Left-arrow.svg`}
							alt="back"
							className="cursor-pointer"
							onClick={() => navigate(-1)}
						/>{' '}
						ADMIN
					</h1>
				</div>
				<div className="navigation-tab shadow-nav-4dp">
					<ul>
						<li
							className={`${activeStep === 'ADMINLIST' ? 'active' : ''}`}
							onClick={() => {
								onTabChange('ADMINLIST');
							}}
						>
							Admin list
						</li>
						<li
							className={`${activeStep === 'ROLE' ? 'active' : ''}`}
							onClick={() => {
								onTabChange('ROLE');
							}}
						>
							Role
						</li>
						<li
							className={`${activeStep === 'DEPARTMENT' ? 'active' : ''}`}
							onClick={() => {
								onTabChange('DEPARTMENT');
							}}
						>
							Department
						</li>
						<li
							className={`${activeStep === 'TEAMS' ? 'active' : ''}`}
							onClick={() => {
								onTabChange('TEAMS');
							}}
						>
							Teams
						</li>
					</ul>
				</div>
				<div className="filter-container-top pt-2 pb-2 bg-gray">
					<div className="filters">
						{(activeStep === 'ADMINLIST' || activeStep === 'TEAMS') && (
							<div className="filter-toggle" onClick={() => setShowFilter(!showFilter)}>
								<img src={`${process.env.PUBLIC_URL}/icons/filter24.svg`} alt="filter" />
								<span>Filter</span>
							</div>
						)}

						<span className="items-count semibold-14 gray_dark_02">{total}</span>
						<div className="ml-3">
							<Chip />
						</div>
					</div>

					<div className="filter-actions">
						<div className="form-group size32 m-0 search-filter filter-with-animation mr-2 mt-1">
							<div
								className={
									!showSearchBox ? 'with-icon right-icon hidden' : 'with-icon right-icon'
								}
							>
								<input
									type="text"
									autoComplete="off"
									placeholder={
										activeStep === 'ADMINLIST'
											? 'Admin name'
											: activeStep === 'ROLE'
												? 'Role name'
												: activeStep === 'DEPARTMENT'
													? 'Department name'
													: activeStep === 'TEAMS'
														? 'Team name'
														: ''
									}
									name="search"
									onChange={handleChange}
									// autoComplete="off"
								/>
								<span
									onClick={() => setShowSearchBox((prevState) => !prevState)}
									className="right-icon"
								>
									<img src={`${process.env.PUBLIC_URL}/icons/search-dark.svg`} alt="" />
								</span>
							</div>
						</div>
						{activeStep === 'DEPARTMENT' ? (
							<button
								className="button text size32 px-0 d-flex align-items-center mt-1"
								onClick={handleClick}
							>
								<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
								<span className="ml-1">Department</span>
							</button>
						) : activeStep === 'ROLE' ? (
							<button
								className="button text size32 px-0 d-flex align-items-center mt-1"
								onClick={addNewRole}
							>
								<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
								<span className="ml-1">Role</span>
							</button>
						) : activeStep === 'ADMINLIST' ? (
							<button
								className="button text size32 px-0 d-flex align-items-center mt-1"
								onClick={addNewAdmin}
							>
								<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
								<span className="ml-1">Admin</span>
							</button>
						) : activeStep === 'TEAMS' ? (
							<button
								className="button text size32 px-0 d-flex align-items-center mt-1"
								onClick={addNewTeam}
							>
								<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
								<span className="ml-1">Team</span>
							</button>
						) : (
							''
						)}
					</div>
				</div>
			</div>
			<section className="filter-data-container filter-v2-data-container orders-data-container">
				{activeStep === 'ADMINLIST' ? (
					<FilterComponent
						key={'adminList_filter'}
						fields={adminPageFieldList}
						showFilter={showFilter}
						processName="Admin"
					/>
				) : activeStep === 'TEAMS' ? (
					<FilterComponent
						key={'adminList_filter'}
						fields={teamPageFieldList}
						showFilter={showFilter}
						processName="Team"
					/>
				) : (
					''
				)}

				<div className="data-table scroll-x-label">
					{activeStep === 'ADMINLIST' ? (
						<AdminList search={search} totalItems={totalItems} />
					) : activeStep === 'ROLE' ? (
						<RoleList search={search} totalItems={totalItems} />
					) : activeStep === 'DEPARTMENT' ? (
						<DepartmentList
							search={search}
							handleClick={handleClick}
							showAdd={showAdd}
							setShowAdd={setShowAdd}
							totalItems={totalItems}
						/>
					) : activeStep === 'TEAMS' ? (
						<TeamList search={search} totalItems={totalItems} />
					) : null}
				</div>
			</section>
		</>
	);
};

export default Admin;
